import React from 'react';
interface LiquidWaveProps {
  color?: string;
  height?: number;
  className?: string;
}
const LiquidWave: React.FC<LiquidWaveProps> = ({
  color = '#3d87e8',
  height = 100,
  className = ''
}) => {
  return <div className={`absolute left-0 right-0 overflow-hidden ${className}`} style={{
    height: `${height}px`
  }} data-id="element-162">
      <svg className="absolute bottom-0 w-full" viewBox="0 0 1200 120" preserveAspectRatio="none" style={{
      height: '100%'
    }} data-id="element-163">
        <defs data-id="element-164">
          <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-165">
            <stop offset="0%" style={{
            stopColor: color,
            stopOpacity: 0.3
          }} data-id="element-166" />
            <stop offset="50%" style={{
            stopColor: color,
            stopOpacity: 0.5
          }} data-id="element-167" />
            <stop offset="100%" style={{
            stopColor: color,
            stopOpacity: 0.3
          }} data-id="element-168" />
          </linearGradient>
        </defs>
        <path d="M0,50 Q300,20 600,50 T1200,50 L1200,120 L0,120 Z" fill="url(#waveGradient)" data-id="element-169">
          <animate attributeName="d" dur="3s" repeatCount="indefinite" values="M0,50 Q300,20 600,50 T1200,50 L1200,120 L0,120 Z;
                    M0,50 Q300,80 600,50 T1200,50 L1200,120 L0,120 Z;
                    M0,50 Q300,20 600,50 T1200,50 L1200,120 L0,120 Z" data-id="element-170" />
        </path>
        <path d="M0,70 Q300,40 600,70 T1200,70 L1200,120 L0,120 Z" fill="url(#waveGradient)" opacity="0.5" data-id="element-171">
          <animate attributeName="d" dur="4s" repeatCount="indefinite" values="M0,70 Q300,40 600,70 T1200,70 L1200,120 L0,120 Z;
                    M0,70 Q300,100 600,70 T1200,70 L1200,120 L0,120 Z;
                    M0,70 Q300,40 600,70 T1200,70 L1200,120 L0,120 Z" data-id="element-172" />
        </path>
      </svg>
    </div>;
};
export default LiquidWave;